import Icon from '@/components/Icon';
import Text from '@/components/Text';
import { JsonLd } from '@/utils/seo';

const features = [
  {
    icon: 'material-symbols:view-in-ar-outline',
    title: '3D Geometry & Feature Extraction',
    description:
      'Automatically recognizes holes, threads, pockets, fillets, and tight tolerances.',
  },
  {
    icon: 'material-symbols:calculate-outline',
    title: 'Dynamic Material & Finishing Calculator',
    description:
      'Instant pricing for Aluminum, Stainless Steel, Titanium, Anodizing, Heat Treating, and Powder Coating.',
  },
  {
    icon: 'material-symbols:schedule-outline',
    title: 'Cycle Time & Machining Costing',
    description:
      'Estimates roughing, finishing, setup, and tooling costs based on geometry.',
  },
  {
    icon: 'material-symbols:layers-outline',
    title: 'Multi-Quantity Price Tiering',
    description:
      'Calculates tiered volume discounts ($1, $10, $100+ units) in real time.',
  },
  {
    icon: 'material-symbols:settings-outline',
    title: 'Customizable Business Rules',
    description:
      'Easily configure hourly shop rates, margin targets, and minimum order values.',
  },
  {
    icon: 'material-symbols:download',
    title: 'Automated PDF & ERP Export',
    description:
      'Generates clean, client-ready PDF quotes and syncs data to CRM/ERP systems.',
  },
];

const CncRfqFeatureGrid = () => {
  return (
    <div className="flex w-full flex-col gap-11">
      <JsonLd
        key="CncRfqSoftwareApplication"
        data={{
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          name: 'MindPal CNC Instant Quote',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web',
          url: 'https://mindpal.co/cnc-rfq',
          description:
            'AI-powered instant quoting engine for CNC and sheet-metal shops — upload a CAD file and get an itemized, editable price in seconds.',
          featureList: features.map(({ title }) => title),
        }}
      />
      <div className="flex flex-col items-center gap-5 text-center">
        <Text
          variant="display-4"
          className="max-w-3xl text-center text-neutral-0"
        >
          Everything a quoting engine needs under one roof
        </Text>
        <Text className="max-w-[511px] text-center text-jb-neutral-600">
          From raw geometry to a costed, exportable quote - the same
          capabilities MindPal can tailor to your shop&apos;s own rules.
        </Text>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {features.map(({ icon, title, description }) => (
          <div
            key={title}
            className="flex flex-col gap-4 rounded-xl border border-neutral-0/[55%] bg-buttonCNC/10 p-6 backdrop-blur-sm lg:min-h-[246px]"
          >
            <div className="flex w-fit items-center justify-center rounded-lg bg-neutral-0/5 p-[10px]">
              <Icon icon={icon} className="text-2xl text-jb-primary-400" />
            </div>
            <Text variant="h4" className="font-semibold text-neutral-0">
              {title}
            </Text>
            <Text className="text-jb-neutral-600">{description}</Text>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CncRfqFeatureGrid;
